import React, { useEffect } from 'react';
import { useState } from 'react';
import { useAuth } from '../../commons/Auth';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import { useLoading } from '../../commons/Loading';
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';
import AlboPresentational from './AlboPresentational';
import { sendMarketingEmail } from '../../lib/fetch/profiles';
import axios from 'axios';

const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

const AlboMarketing = ({ profile }) => {
  const [{ newToken } = {}] = useAuth();
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [t] = useTranslation('CONTACTS');
  const alert = useAlert();
  const { showLoading, hideLoading } = useLoading();
  const [selected, setSelected] = useState([]);

  const handleSelectChange = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
    );
  };

  const [query, setQuery] = useQueryParams({
    type: withDefault(StringParam),
    profileStatus: withDefault(StringParam),
    search: withDefault(StringParam),
    offset: NumberParam,
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    region: withDefault(StringParam),
    district: withDefault(StringParam),
  });

  const { search, offset, limit, type, profileStatus, region, district } =
    query;

  useEffect(() => {
    const fetchProfiles = async () => {
      showLoading();

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/albo`,
        {
          headers: { Authorization: newToken },
          params: {
            search,
            offset,
            limit,
            type,
            profileStatus,
            region,
            district,
          },
        }
      );

      hideLoading();

      if (response instanceof Error) {
        return alert.error(t('COMMON:GENERIC_ERROR'));
      }

      const { data = [], headers = {} } = response;

      setData(data);
      setTotal(Number(headers['x-total-count']));
      hideLoading();
    };

    fetchProfiles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, offset, limit, type, profileStatus, region, district]);

  function onFilter(query) {
    if (
      (query.search && query.search !== search) ||
      (search && query.search === '') ||
      (query.type && query.type !== type) ||
      (type && query.type === '') ||
      (query.profileStatus && query.profileStatus !== profileStatus) ||
      (profileStatus && query.profileStatus === '') ||
      (query.region && query.region !== region) ||
      (region && query.region === '') ||
      (query.district && query.district !== district) ||
      (district && query.district === '') ||
      (query.limit && query.limit !== limit)
    ) {
      query.offset = 0; // return to first page
    }
    setQuery(query);
  }

  const handleSendEmail = async (subject, body, cc) => {
    const { error, data: responseData } = await sendMarketingEmail({
      profileIds: selected,
      subject,
      body,
      cc,
      newToken,
    });

    if (error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    setSelected([]);
    alert.success(
      responseData?.message ||
        `Email inviata a ${responseData?.sent || 0} destinatari.`
    );
  };

  return (
    <AlboPresentational
      data={data}
      total={total}
      query={query}
      onFilter={onFilter}
      selected={selected}
      onSelectChange={handleSelectChange}
      onSendEmail={handleSendEmail}
      newToken={newToken}
    />
  );
};

export default AlboMarketing;
